import { render, staticRenderFns } from "./MigrationModal.vue?vue&type=template&id=4d64f5b6"
import script from "./MigrationModal.vue?vue&type=script&lang=js"
export * from "./MigrationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports